import 'raf/polyfill';
import '@bibliocommons/polyfills';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import Immutable from 'immutable';
import Iso from 'iso';
import { Provider } from 'react-redux';
import { loadableReady } from '@loadable/component';

import ApiClient from './api/ApiClient';
import createReduxStore from './helpers/redux/createReduxStore';
import ApplicationContainer from './ApplicationContainer';
import ApplicationRouter from './ApplicationRouter';

// Prevent safari loading from cache when back button is clicked
window.onpageshow = function handleSafariBFCache(event) {
  if (event.persisted && typeof window.parentIFrame === 'undefined') {
    window.location.href += '&reload=true';
  }
};

// Boot up the React application
Iso.bootstrap(reduxStoreData => {
  const rootElement = document.getElementById('react-root');

  const { apiGatewayURL, libraryDomain, enableWebpackHMR, enableReduxDevTools } = reduxStoreData.app;

  const reduxState = Immutable.fromJS(reduxStoreData);
  const currentLanguage = reduxStoreData.localization.currentLanguage;

  const apiClient = new ApiClient({
    subdomain: libraryDomain,
    locale: currentLanguage,
    apiGatewayURL
  });

  const reduxStore = createReduxStore(reduxState, apiClient, enableWebpackHMR, enableReduxDevTools);

  loadableReady(() => {
    // React 18 root API. Note hydrateRoot takes (container, element) -- the reverse of
    // ReactDOM.hydrate(element, container). CORE-78275.
    hydrateRoot(
      rootElement,
      <Provider store={reduxStore}>
        <ApplicationContainer>
          <ApplicationRouter />
        </ApplicationContainer>
      </Provider>
    );
  });
});
